import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './NoDateLecturesGrid.css';
import LectureCard from '../lectureCard/LectureCard';
import {TTimetableItem} from '../../../../redux/timetable/timetable.type';

interface NoDateLecturesGridProps {
    lectures: TTimetableItem[];
    expanded?: boolean;
    onEditLecture?: (item: TTimetableItem) => void;
    onTicketsClick?: (item: TTimetableItem) => void;
}

const NoDateLecturesGrid: FC<NoDateLecturesGridProps> = ({
    lectures,
    expanded = true,
    onEditLecture = () => {},
    onTicketsClick = () => {},
}) => {
    const {t} = useTranslation('timetable');
    const items = lectures.filter(l => !l.isBreak);

    if(items.length === 0) return <css.empty>{t('noLectures')}</css.empty>;

    return (
        <css.grid data-cy="timetable-no-date-grid">
            {items.map(l => (
                <LectureCard
                    key={l.ttid}
                    lecture={l}
                    expanded={expanded}
                    onTicketsClick={() => onTicketsClick(l)}
                    onEdit={() => onEditLecture(l)}
                    disableDrag
                />
            ))}
        </css.grid>
    );
};

export default NoDateLecturesGrid;
